import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCSearchHondentaalLichaamstaalPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5761" data-mp="1dulyias47ubu">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5762" data-mp="1nqyph0w9zu2w">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5763" data-mp="1snfctsvni4ex">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5764" data-mp="21i3l7rwiw27y">
              <XIcon className="w-6 h-6" data-id="element-5765" data-mp="2bg17wayqhqyg" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5766" data-mp="2bgaxvyjs3y45">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-hondentaal-lichaamstaal" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5767" data-mp="pudkchjbgzjg"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5768" data-mp="14kuldzs1hnft">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5769" data-mp="utgp00vdx3qw">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5770" data-mp="1s82p4d9tkofq" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5771" data-mp="26fo36x0cjl2d">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5772" data-mp="21l1tqzdts2kx">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5773" data-mp="1nmbvhgf9rwuz">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5774" data-mp="1smgdxbzqn1nu" />
          <div className="hidden md:block" data-id="element-5775" data-mp="1ioioil656ytn">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5776" data-mp="390pqz9yj53zd">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5777" data-mp="xee2r5nxi0w9">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5778" data-mp="1l25pz4b0bycb">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5779" data-mp="1l4i8bikogapw">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5780" data-mp="3vvi1drqd5rx2">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5781" data-mp="1685i3epgr75">
        <div className="md:col-span-7" data-id="element-5782" data-mp="652rtfbvsxw0">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-5783" data-mp="66dybmwpojqt">
            Gratis Online Webinar: Honden-Lichaamstaal
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5784" data-mp="39mtcjens1a7m">
            Leer honden-lichaamstaal lezen - zodat je écht weet wat je hond
            bedoelt
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5785" data-mp="3jk7gwfwfe8jk">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5786" data-mp="2vu4sqavmtmq8">
            <div className="flex -space-x-3" data-id="element-5787" data-mp="2ob41any3vjj8">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5788" data-mp="2oavmurmc465x" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5789" data-mp="29ed5sprjyryw" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5790" data-mp="20k87jla3ae9c" />
            </div>
            <div data-id="element-5791" data-mp="1loscpe1oqebw">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5792" data-mp="1ln8x7pnus7b6">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5793" data-mp="1hmoyihnmsvmx">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5794" data-mp="173y0uya3a7da">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om de hondentaal en
            lichaamstaal van hun hond te leren begrijpen - zodat ze direct zien
            wat hun hond denkt, voelt en nodig heeft.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5795" data-mp="1qr44v85p2p0k">
            {['Waarom honden voor 95% met hun lichaam communiceren - en hoe je leert "luisteren met je ogen"', 'De belangrijkste kalmerings- en stresssignalen die elke hond gebruikt (en die de meeste baasjes missen)', 'Wat de stand van oren, staart, ogen, mond en lichaamshouding echt betekent', 'Hoe je subtiele signalen herkent vóórdat ze uitgroeien tot blaffen, uitvallen of angst', 'Hoe je de wereld leert zien vanuit je hond - zodat "onverklaarbaar gedrag" ineens logisch wordt', "Hoe je met je eigen lichaamstaal duidelijk maakt wat je wilt - zonder commando's of correcties"].map((item, i) => <li key={i} className="flex items-start" data-id="element-5796" data-mp="2xk0hahkpbfqz" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5797" data-mp="2xjifz6j6mbc7" />
                <span className="text-gray-700 font-medium" data-id="element-5798" data-mp="2sm8gey22wjan">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5799" data-mp="24vmku699grhj">
            <div className="flex -space-x-3" data-id="element-5800" data-mp="20uj65n2y91hw">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5801" data-mp="20vu9jlshg78h" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5802" data-mp="3q7wc1gqpmxl4" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5803" data-mp="1jic9zbif4rof" />
            </div>
            <div data-id="element-5804" data-mp="1xclpi88m6459">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5805" data-mp="1xd4ukod60y1v">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5806" data-mp="229vclh8j63px">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5807" data-mp="2bburo3zzixq8">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5808" data-mp="2bce9zltjro4s">
            <div className="flex justify-center items-center w-full" data-id="element-5809" data-mp="2g9mu3ry9a28o">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-hondentaal-lichaamstaal" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5810" data-mp="gxtvjqvtkotu"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5811" data-mp="xc9th0ajqti9">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5812" data-mp="xb8e4jmhzkuq">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5813" data-mp="sdyjmpk94j01">
            Leer honden-lichaamstaal lezen in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5814" data-mp="nfoo2dum7gdw">
            <div className="flex flex-col items-center" data-id="element-5815" data-mp="jbgykegc1wem">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5816" data-mp="383t2wlq8ir1c" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5817" data-mp="3eanmrwjq405q">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5818" data-mp="3a921pnx1cfkg">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5819" data-mp="3o0yqbhzhw7c3">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5820" data-mp="3j8p4ad1i3rf3" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5821" data-mp="3syh4pnwa7erh">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5822" data-mp="aruf20dmm5jh">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5823" data-mp="2cjpb57neg1gl">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5824" data-mp="2cmbpbq4spf7s" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5825" data-mp="s1ep97airxb7">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5826" data-mp="ebl16r6u9h2j">
                Leer in 90 minuten hoe je de honden-lichaamstaal van je hond
                leest en begrijpt
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5827" data-mp="4cm2o1fsf1t9">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5828" data-mp="3vjoqciwf2pyq">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5829" data-mp="1pqhvafhvqwgr">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5830" data-mp="1po3zg4fdlg85">
            Duizenden baasjes leerden inmiddels de taal van hun hond lezen - en
            zeggen allemaal hetzelfde: <br data-id="element-5831" data-mp="2xpniyi8px3a1" />
            <span className="italic" data-id="element-5832" data-mp="2xp5ptuhcr56c">
              "Ik zie nu pas wat mijn hond al die tijd probeerde te vertellen."
            </span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5833" data-mp="2tpwtqiyuav7m">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5834" data-mp="2oqjypaxtehty">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5835" data-mp="3lfhxd48oqzwe">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5836" data-mp="3cmy46jb5xniy"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5837" data-mp="lgp0lj540hxb">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5838" data-mp="lijjyt0qg1za">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5839" data-mp="ugc2e61r3pqw"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5840" data-mp="14iftcueccg1t">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5841" data-mp="10j6x9ivtw633">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5842" data-mp="19apelx4igrxr"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5843" data-mp="21yl9qxefmbsf">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5844" data-mp="3jwhtyt1qlcyk">
              <div className="flex items-center mb-4" data-id="element-5845" data-mp="3ovulhr3jz87h">
                <div className="flex text-green-500 mr-2" data-id="element-5846" data-mp="3oxe1dglarh8q">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5847" data-mp="3ayedib5lz6dm" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5848" data-mp="3fx925tq9bp5n">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5849" data-mp="7hytu3vrxnpf">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5850" data-mp="3tuxci7mp7dwg">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5851" data-mp="v1or32yzjbbx">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5852" data-mp="q69a425okzba">
              <div className="flex items-center mb-4" data-id="element-5853" data-mp="m4edvc2lxc4d">
                <div className="flex text-green-500 mr-2" data-id="element-5854" data-mp="hajw4e6kb77x">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5855" data-mp="cd9xc7xa9j7f" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5856" data-mp="7eypg2qjtiru">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5857" data-mp="2d0zkpnn7ppx">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5858" data-mp="3uk7t7nl7chju">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5859" data-mp="20aj4p6l2qxh3">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5860" data-mp="251rei3qbgkus">
              <div className="flex items-center mb-4" data-id="element-5861" data-mp="17mdfo7mzmmbg">
                <div className="flex text-green-500 mr-2" data-id="element-5862" data-mp="17jra2djnqgvv">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5863" data-mp="5xckqcx5fq1v" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5864" data-mp="yjbiwowal7i">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5865" data-mp="exsq5rxgd79d">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5866" data-mp="9xmrhrsrmkhs">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5867" data-mp="1m7c7sk11u7q2">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5868" data-mp="1cbqwfva3bv3n">
              <div className="flex items-center mb-4" data-id="element-5869" data-mp="1ha25w4wh43lc">
                <div className="flex text-green-500 mr-2" data-id="element-5870" data-mp="1h8r60g65ffzi">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5871" data-mp="13guf2fg7vc4p" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5872" data-mp="18bgssp9rtgry">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5873" data-mp="tin2e8syng8i">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5874" data-mp="kjt7cmva2xx2">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5875" data-mp="3awgpv94gb1v6">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5876" data-mp="31xv7pf2w5oux">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5877" data-mp="2h6q47o1a8qk">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5878" data-mp="2k2oty7ph1g2">
          <div data-id="element-5879" data-mp="3ku4woxfbzztp">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5880" data-mp="3oxt3hdw52rdw">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5881" data-mp="ggg2sxd16kps">
              <p data-id="element-5882" data-mp="l9rfvg8frxq5">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. En ik weet hoe het voelt als je het gevoel
                hebt dat je hond je iets probeert te vertellen - maar dat je
                niet weet wat.
              </p>
              <p data-id="element-5883" data-mp="2fnwk0almnuxs">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes
                geleerd hoe ze de honden-lichaamstaal van hun hond kunnen lezen.
                Want zodra je die taal begrijpt, valt er een wereld voor je
                open: je ziet wanneer je hond zich onzeker voelt, wanneer hij
                speels is, wanneer hij stress opbouwt, en wanneer hij iets nodig
                heeft van jou.
              </p>
              <p data-id="element-5884" data-mp="1rzdc3w6hpk68">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                tussen baasjes en honden niet ontstaat door een 'slecht' hond of
                een 'falende' baas. Ze ontstaat doordat we letterlijk twee
                verschillende talen spreken. Honden communiceren voor 95% met
                hun lichaam - oren, staart, ogen, houding, ademhaling - terwijl
                wij vooral met onze stem praten. Geen wonder dat we elkaar vaak
                misverstaan.
              </p>
              <p data-id="element-5885" data-mp="3kgy39g5x740x">
                Daarom leer ik baasjes geen commando's of trucjes, maar iets
                veel waardevollers: hoe je hondentaal leest, hoe je je eigen
                lichaamstaal bewust inzet, en hoe je een gesprek voert in plaats
                van bevelen geeft. Geen dwang, geen straf, geen correcties.
                Alleen liefdevolle, echte communicatie.
              </p>
              <p data-id="element-5886" data-mp="31odo11j58xfl">
                Dit webinar is mijn manier om deze kennis met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te verstaan.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5887" data-mp="2dz15hb1xfd0m">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5888" data-mp="v4pwuotlkgu1" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5889" data-mp="h5ghtsh4nsrn">
        <div className="max-w-md mx-auto px-4" data-id="element-5890" data-mp="h4oxxeww7jh7">
          <div className="p-6 rounded-3xl w-full" data-id="element-5891" data-mp="c6do346ll8yz">
            <div className="flex justify-center items-center" data-id="element-5892" data-mp="c757zhqu1i9f">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-hondentaal-lichaamstaal" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5893" data-mp="7evpunvylmhp"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5894" data-mp="1thlyq2oi3dxu">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5895" data-mp="1tgu8l7doa8ey">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5896" data-mp="1es6aougctmlu" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5897" data-mp="1ar48q5v1ywg6">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5898" data-mp="vud85t9n7eoz">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5899" data-mp="2q84fun8evohs">
            <p className="mb-2" data-id="element-5900" data-mp="2q5s4isx5scdp">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5901" data-mp="jjm0jjqhztin">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5902" data-mp="1c78enlxcqgjr" />
    </div>;
}